import React from 'react';

import Component from '../../../ui-components/Component';
import Page from '../../../ui-components/Page';
import { withResizer, withTranslations } from '../../../HoCs';
import ManualFlow from '../Create/components/ManualFlow';
import { path } from '../../../utils';
import pages, { getRouteForPage } from '../../../PageEnums';
import CyclicFooter from '../../../ui-components/Banners/CyclicFooter';
import { hmsSelfOnboardingEnabled } from '../../../config/countryConfig';
import { forceLogout } from '../../../services/Network';

class PropertyEdit extends Component {
    
    translation_key = 'properties_translations';
    
    componentDidMount = () => hmsSelfOnboardingEnabled() && forceLogout();

    render = () => <Page title={this.gc('edit_property_details')} contentStyle={{ overflowY: 'none', position: 'relative' }} renderFooter={() => <CyclicFooter style={this.gs('footer')} />}>
        <ManualFlow
            title='edit_property_information' className='fillSpace'
            id={path(this.props.match, 'params.id')}
            backRoute={getRouteForPage(pages.PROPERTIES, path(this.props.match, 'params.id'))}
            loadingText='updating_property_details' successText='property_details_updated' actionText='Back'
            finalPageRedirection={getRouteForPage(pages.PROPERTIES, path(this.props.match, 'params.0'))}
            gc={this.gc}/>
    </Page>;

}

export default withTranslations(withResizer(PropertyEdit));
